/** @jsxImportSource @emotion/react */
import { InputSwitch } from "primereact/inputswitch";
import * as estilos from "./estilosGenerador";

// Una pregunta sí/no del generador. La pregunta ocupa todo el ancho que
// quede y el interruptor no se achica nunca (en mobile, con preguntas largas,
// se deformaba). Toda la fila es clickeable a través del label.
export default function CampoGeneradorEtiquetas({ titulo, cambioConfiguracion, id, valor }) {
  return (
    <div css={estilos.fila}>
      <label htmlFor={id} css={estilos.pregunta}>
        {titulo}
      </label>
      <InputSwitch
        inputId={id}
        checked={valor || false}
        onChange={(e) => {
          cambioConfiguracion({ target: { checked: e.value } }, id);
        }}
        css={{ flexShrink: 0 }}
      />
    </div>
  );
}
